import { Component, Watch } from 'vue-property-decorator';
import LocalityService from '@/services/locality.service';
import { LocalityDTO } from '@/models/LocalityDTO';
import { ThingDTO } from '@/models/ThingDTO';
import AutoComplete from '@/components/inputs/base/AutoComplete/AutoComplete.vue';
import { WatchOptions } from 'vue';
import ApiError from '@/exceptions/api.error';

@Component
export default class LocalityAutoComplete extends AutoComplete<LocalityDTO> {
  public localities: LocalityDTO[] = [];
  public errorMessage: string = '';
  public error: boolean = false;

  public convertValue(): LocalityDTO {
    return this.localities.find((x) => x.locId === this.search.id) as LocalityDTO;
  }

  public handleClickOutside(evt: any): void {
    if (!this.$el.contains(evt.target)) {
      this.isOpen = false;
      this.arrowCounter = -1;
      if (this.search && this.search.id === -99) {
        this.$emit('input', undefined);
        this.search.name = '';
      }
    }
  }

  protected formatSearchLabel(value: LocalityDTO) {
    if (value.locZipCode){
      return `${value.locZipCode} - ${value.locName}`;
    } else {
      return value.locName;
    }
  }

  protected onChange(value: string): void {
    super.onChange(value);
  }

  protected mounted() {
    this.loadLocalities();
    super.mounted();

    if (this.value) {
      this.search = {
        id: this.value.locId,
        name: this.formatSearchLabel(this.value),
      } as ThingDTO;
    }
  }

  protected loadLocalities(): void {
    LocalityService.fetchLocalities()
      .then((res: LocalityDTO[]) => {
        this.localities = res.map((x) => x as LocalityDTO);
        this.items = this.localities.map((x: LocalityDTO) => {
          return { name: x.locZipCode + ' - ' + x.locName, id: x.locId } as ThingDTO;
        });
      })
      .catch((error: ApiError) => {
        this.error = true;
        switch (error.status) {
          case (500):
            this.errorMessage = this.$i18n.t('errorMgs.serverError').toString();
            break;
          case (401):
            this.errorMessage = this.$i18n.t('errorMgs.sessionExpiration').toString();
            break;
          default:
            this.errorMessage = error.message;
        }
      });
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: LocalityDTO, oldValue: LocalityDTO) {
    if (oldValue !== value && value !== undefined && value !== null) {
      this.search = {
        id: value.locId,
        name: this.formatSearchLabel(value),
      } as ThingDTO;
    }

    if (value === null || value === undefined) {
      this.search = { name: '' } as ThingDTO;
    }
  }
}

